import React from "react";
import { MainLayout } from "@components/layouts/MainLayout";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { Database, GitBranchPlus } from "lucide-react";
import { Button } from "@components/ui/button";
import { Card } from "@components/ui/card";
import { requestApplySuperoneApiDataEmbeddings } from "@helpers/requestApplySuperoneApiDataEmbeddings";

const AiData: React.FC = () => {
  const [embeddingLoading, setEmbeddingLoading] = React.useState(false);
  const [embeddingResult, setEmbeddingResult] = React.useState<string | null>(
    null
  );
  const [embeddingError, setEmbeddingError] = React.useState<string | null>(
    null
  );

  const handleApplyEmbeddings = async () => {
    setEmbeddingLoading(true);
    setEmbeddingResult(null);
    setEmbeddingError(null);
    try {
      const res = await requestApplySuperoneApiDataEmbeddings();
      setEmbeddingResult(
        typeof res === "string"
          ? res
          : res?.message || "Embeddings applied successfully."
      );
    } catch (e: any) {
      setEmbeddingError(e.message || "Failed to apply embeddings");
    } finally {
      setEmbeddingLoading(false);
    }
  };

  return (
    <Card className="hover:shadow-lg transition-shadow duration-200 overflow-hidden p-6 border border-gray-800">
      <h2 className="text-lg font-semibold font-heading mb-4 flex items-center text-superone-charcoal">
        <GitBranchPlus className="mr-2 h-5 w-5 text-green-500" />
        AI Embeddings
      </h2>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-start">
          <span className="text-yellow-700 bg-yellow-100 rounded px-2 py-1 font-medium mb-4">
            Do not use this section unless you understand the implications of
            applying SuperOne API AI embeddings.
          </span>
          <Button
            type="button"
            onClick={handleApplyEmbeddings}
            disabled={embeddingLoading}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 disabled:opacity-50 cursor-pointer font-normal"
          >
            {embeddingLoading
              ? "Applying SuperOne API AI Embeddings"
              : "Apply SuperOne API Data AI Embeddings"}
          </Button>
        </div>
        {embeddingResult && (
          <div className="text-green-600 text-sm mt-2">{embeddingResult}</div>
        )}
        {embeddingError && (
          <div className="text-red-600 text-sm mt-2">{embeddingError}</div>
        )}
      </div>
    </Card>
  );
};

export default AiData;
